/** Research guide §3 — Running discovery (`research/ResearchRunView.tsx`). */
import { helpSectionMeta } from '../help-sections.js';
import {
  Btn,
  Bullets,
  Callout,
  HelpSectionCard,
  Li,
  P,
  SectionLink,
  Shot,
  SubHead,
} from '../HelpPrimitives.js';

export function ResearchRun(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('research-run')}>
      <Shot
        slug="research-run"
        caption="Live discovery progress: the stage rail, progress bar and partial results."
      />
      <P>
        Live progress for the free discovery pass — a 5-stage rail, a progress bar, and a
        partial-results table that fills in as companies are found. A recap panel reminds you of the
        request&rsquo;s criteria.
      </P>

      <SubHead>What you can do here</SubHead>
      <Bullets>
        <Li>
          <Btn>Cancel</Btn> the run, or <Btn>Retry errors</Btn> if some companies failed.
        </Li>
        <Li>
          <Btn>Review long-list</Btn> — opens once the long-list is ready.
        </Li>
        <Li>
          <Btn>AI check</Btn> — just navigation, to the{' '}
          <SectionLink to="research-aichain">AI chain</SectionLink> screen; it spends nothing by
          itself.
        </Li>
        <Li>
          <Btn>Edit criteria</Btn> — go back and adjust the request.
        </Li>
      </Bullets>

      <P>
        If a run fails or comes back thin, you&rsquo;ll also see <Btn>Resume</Btn>,{' '}
        <Btn>Broaden criteria</Btn> or <Btn>Review anyway</Btn>.
      </P>

      <Callout title="This screen doesn't spend anything">
        <P>
          Discovery and dedup are free lookups against the company library — the AI-costing steps
          only start on the AI chain screen, and only when you explicitly select companies there and
          click.
        </P>
      </Callout>
    </HelpSectionCard>
  );
}
